import { Box } from "@mui/material"


export const VerticalGap = ({ h }: { h: number }) => {
    return (
        <Box sx={{ height: `${h}px` }}></Box>
    )
}